import React from 'react'

import { useResponsiveDropdown } from 'components/ResponsiveDropdown'
import Selector from '../Selector'

import { ReactComponent as DotIcon } from '@sketch/icons/dots-3-horizontal-16-svg'
import AnnotationOptionsDropdown from '../AnnotationOptionsDropdown'
import {
  AnnotationOptionsBackground,
  AnnotationOptionsWrapper,
} from './AnnotationInboxOptions.styles'
import ResolveAnnotationButton from '../ResolveAnnotationButton'
import { useFlag } from 'containers/flags'

const DROPDOWN_MODIFIERS = [
  { name: 'computeStyles', options: { adaptive: true, gpuAcceleration: true } },
]

const optionsWrapperOnClick = (event: React.MouseEvent) => {
  event.stopPropagation()
  event.preventDefault()
}

interface AnnotationInboxOptionsProps
  extends React.ComponentProps<typeof AnnotationOptionsDropdown> {
  className?: string
}

const AnnotationInboxOptions = (props: AnnotationInboxOptionsProps) => {
  const { className, ...dropdownProps } = props

  const allowResolvedAnnotations = useFlag('resolve-annotations')
  const [content, buttonProps] = useResponsiveDropdown({
    dropdown: AnnotationOptionsDropdown,
    dropdownProps,
    placement: 'bottom-end',
    modifiers: DROPDOWN_MODIFIERS,
  })

  return (
    <>
      <AnnotationOptionsWrapper
        className={className}
        aria-expanded={buttonProps['aria-expanded']}
        onClick={optionsWrapperOnClick}
      >
        {allowResolvedAnnotations && (
          <ResolveAnnotationButton
            annotationIdentifier={dropdownProps.annotationIdentifier}
            isResolved={!!dropdownProps.isResolved}
          />
        )}
        <Selector data-testid="annotation-options" {...buttonProps}>
          <DotIcon role="img" />
          <span className="sr-only">Options</span>
        </Selector>
        <AnnotationOptionsBackground />
      </AnnotationOptionsWrapper>
      {content}
    </>
  )
}

export default AnnotationInboxOptions
